export enum RolesEnum {
    superAdmin = 'super_admin',
    manager = 'manager',
    superManager = 'super_manager',
    marketing = 'marketing',
}